import { React } from "react";
import { FormWithRedirect, SaveButton } from "react-admin";
import { DeleteWithConfirmButton } from "ra-ui-materialui";
import { Box, Toolbar, makeStyles, Divider, Button } from "@material-ui/core";

import { usePopup } from "react-hook-popup";
import SimplePopupDialog from "../../../components/SimplePopupDialog";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => {
  return {
    buttonContainer: {
      display: "grid",
      gridTemplateColumns: "50% 50%",
      paddingBottom: "20px",
    },
    noDeletebuttonContainer: {
      display: "grid",
      gridAutoFlow: "column",
      alignItems: "center",
      width: "100%",
      paddingBottom: "20px",
    },
    button: { height: 55, fontSize: 24 },
    createButton: {
      width: 250,
      height: 55,
      fontSize: 24,
      margin: "0 auto",
    },
  };
});

// const CustomFormx = (props) => {
//   const { children, validate } = props;
//   const classes = useStyles();

//   return (
//     <SimpleForm {...props}>
//       <Typography>{JSON.stringify(validate)}</Typography>
//       {children}
//     </SimpleForm>
//   );
// };

const CustomForm = (props) => {
  const { children, validate, noDelete, disabled, fromEdit = false } = props;
  const classes = useStyles();
  const history = useHistory();
  const [showPopup] = usePopup("alert", ({ message, handleClose }) => (
    <SimplePopupDialog
      message="Are you sure you want to leave this page? The data you have entered may not be saved."
      title="Cancel ?"
      cancelButton="Stay on Page"
      confirmButton="Leave Page"
      handleClose={handleClose}
      onConfirm={history.goBack}
      haveCanceltoClose={true}
    />
  ));

  return (
    <FormWithRedirect
      {...props}
      redirect="list"
      validate={validate}
      render={(formProps) => (
        // here starts the custom form layout
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            flex: "auto 120px",
            height: "100%",
          }}
        >
          <>
            <Box
              style={{ height: "100%", overflowY: "auto", overflowX: "hidden",marginBottom: "20px" }}
            >
              {children.map((child) => (
                <>
                  {child}
                  <Divider style={{ backgroundColor: "white" }} />
                </>
              ))}
            </Box>
            <Toolbar>
              {noDelete ? (
                <Box className={classes.noDeletebuttonContainer}>
                  <Button onClick={showPopup}>Cancel</Button>

                  <SaveButton
                    saving={formProps.saving}
                    handleSubmitWithRedirect={
                      formProps.handleSubmitWithRedirect
                    }
                    className={classes.createButton}
                    label={fromEdit ? "Edit" : "Create"}
                    disabled={disabled}
                  />
                </Box>
              ) : (
                <Box width="100%" className={classes.buttonContainer}>
                  {noDelete ? null : (
                    <DeleteWithConfirmButton
                      confirmTitle="Delete this item?"
                      record={formProps.record}
                      className={classes.button}
                      disabled={disabled}
                    />
                  )}
                  <SaveButton
                    saving={formProps.saving}
                    handleSubmitWithRedirect={
                      formProps.handleSubmitWithRedirect
                    }
                    className={classes.button}
                    disabled={disabled}
                  />
                </Box>
              )}
              {/* <Box width="100%" className={classes.buttonContainer}>
                {noDelete ? null : (
                  <DeleteWithConfirmButton
                    confirmTitle="Delete this item?"
                    record={formProps.record}
                    className={classes.button}
                  />
                )}
                <SaveButton
                  saving={formProps.saving}
                  handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
                  className={classes.button}
                />
              </Box> */}
            </Toolbar>
          </>
        </form>
      )}
    />
  );
};

export default CustomForm;
